import styled from 'styled-components';
import theme from 'theme';
export const IconContainer = styled.div``;
export const HeaderText = styled.div`
  font-size: 20px;
  margin-left: 10px;
  font-weight: 600;
`;
export const TooltipIconContainer = styled.div`
  display: flex;
  margin-left: 4px;
  align-items: center;
`;
export const TooltipIcon = styled.div``;
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
`;
export const PermissionText = styled.div`
  font-size: 14px;
  color: ${theme.colors.colorSemiDarkGray1};
  font-weight: 400;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid ${theme.colors.colorMediumGray5};
  padding-bottom: 4px;
`;

export const Section = styled.div`
  margin-bottom: 30px;
`;
export const Container = styled.div``;

export const StyledAdminInitials = styled.div`
  flex: 1;
`;

export const StyledAdminName = styled.div`
  font-size: 12px;
  font-weight: 600;
  flex: 1;
`;
export const RemoveText = styled.div`
  flex: 1;
  text-align: right;
  font-size: 12px;
  cursor: pointer;
  color: ${theme.colors.colorDeleteRed};
  visibility: hidden;
`;

export const StyledAdminRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 15px;
  background: ${theme.colors.colorPureWhite};
  border-bottom: 1px solid ${theme.colors.colorPaleGray5};

  &:last-child {
    border-bottom: transparent;
  }

  &:hover {
    ${RemoveText} {
      visibility: visible;
    }
  }
`;

export const StyledAdminEmail = styled.div`
  font-size: 12px;
  flex: 3;
`;
export const StyledGraphicDisplay = styled.div`
  width: 300px;
  display: flex;
  margin-top: 150px;
  justify-content: center;
`;

export const PermissionsHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  position: sticky;
  z-index: 5;
  top: 0px;
  background: ${theme.colors.colorTranslucentGray4};
  border-bottom: 2px solid ${theme.colors.colorMediumGray5};
  padding-bottom: 10px;
  margin-bottom: 30px;
`;

export const CollapeExpandContainer = styled.div`
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
`;
